import { useRef, useEffect } from 'react';
import paper from 'paper';

const RiverPreview = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);
    const w = paper.view.size.width;
    const h = paper.view.size.height;

    const defs = [
      { color: 'blue',       speed: 0.001, amp: 2, sw: 8  },
      { color: 'blue',       speed: 0.003, amp: 3, sw: 5  },
      { color: 'lightblue',  speed: 0.005, amp: 2, sw: 10 },
      { color: 'blue',       speed: 0.002, amp: 4, sw: 4  },
    ];
    const waves = defs.map(d => {
      const wave = new paper.Path();
      wave.strokeColor = d.color;
      wave.strokeWidth = d.sw;
      return wave;
    });

    const onFrame = () => {
      waves.forEach((wave, i) => {
        const d = defs[i];
        const time = Date.now() * d.speed;
        wave.segments = [];
        for (let x = 0; x <= w; x += 3) {
          const y = 12 * d.amp * Math.sin(x * 0.05 + time + i * 20) + h / 2 + (i - 1.5) * 18;
          wave.add(new paper.Point(x, y));
        }
      });
    };

    paper.view.on('frame', onFrame);
    return () => { paper.view.off('frame', onFrame); paper.project.clear(); };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: 'white' }} />;
};

export default RiverPreview;
